/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArchiveBoxOpenDocsIcon16Light } from './ArchiveBoxOpenDocsIcon16Light';
import { ArchiveBoxOpenDocsIcon16Regular } from './ArchiveBoxOpenDocsIcon16Regular';
import { ArchiveBoxOpenDocsIcon16Solid } from './ArchiveBoxOpenDocsIcon16Solid';
import { ArchiveBoxOpenDocsIcon20Light } from './ArchiveBoxOpenDocsIcon20Light';
import { ArchiveBoxOpenDocsIcon20Regular } from './ArchiveBoxOpenDocsIcon20Regular';
import { ArchiveBoxOpenDocsIcon20Solid } from './ArchiveBoxOpenDocsIcon20Solid';
import { ArchiveBoxOpenDocsIcon24Regular } from './ArchiveBoxOpenDocsIcon24Regular';
import { ArchiveBoxOpenDocsIcon24Solid } from './ArchiveBoxOpenDocsIcon24Solid';
import { ArchiveBoxOpenDocsIcon32Regular } from './ArchiveBoxOpenDocsIcon32Regular';
import { ArchiveBoxOpenDocsIcon64Regular } from './ArchiveBoxOpenDocsIcon64Regular';
var sizes = {
    16: {
        light: ArchiveBoxOpenDocsIcon16Light,
        regular: ArchiveBoxOpenDocsIcon16Regular,
        solid: ArchiveBoxOpenDocsIcon16Solid,
    },
    20: {
        light: ArchiveBoxOpenDocsIcon20Light,
        regular: ArchiveBoxOpenDocsIcon20Regular,
        solid: ArchiveBoxOpenDocsIcon20Solid,
    },
    24: {
        regular: ArchiveBoxOpenDocsIcon24Regular,
        solid: ArchiveBoxOpenDocsIcon24Solid,
    },
    32: {
        regular: ArchiveBoxOpenDocsIcon32Regular,
    },
    64: {
        regular: ArchiveBoxOpenDocsIcon64Regular,
    },
};
export var ArchiveBoxOpenDocsIcon = forwardRef('ArchiveBoxOpenDocsIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
